import { useRef, useEffect } from 'react';
import autoAnimate, {
  AutoAnimationPlugin,
  AutoAnimateOptions,
} from '@formkit/auto-animate';

/**
 * AutoAnimate hook for adding dead-simple transitions and animations to react.
 *
 * This is copied directly from the library's source because it didn't work consistently.
 * Source: https://github.com/formkit/auto-animate/blob/8f9dc868c03e5c065a076db0308e52424f462bf7/src/react/index.ts
 * Issue: https://github.com/formkit/auto-animate/issues/8
 *
 * @param options - Auto animate options or a plugin
 * @returns
 */
function useAutoAnimate<T extends HTMLElement>(
  options: Partial<AutoAnimateOptions> | AutoAnimationPlugin = {},
  dependencies: any[] = [],
) {
  const element = useRef<T>(null);
  useEffect(() => {
    if (element.current instanceof HTMLElement)
      autoAnimate(element.current, options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [element.current, options, ...dependencies]);
  return [element];
}

export { useAutoAnimate };
